/**
 * Level load helpers — plain data, no schema package dependency yet.
 * content-schema bead will validate; sim accepts LevelDef structurally.
 */
export function loadLevel(data) {
    if (!data.id) {
        throw new Error("LevelDef.id is required");
    }
    if (!Number.isFinite(data.startN) || data.startN < 0) {
        throw new Error(`LevelDef.startN invalid: ${data.startN}`);
    }
    if (!Number.isFinite(data.pathLength) || data.pathLength <= 0) {
        throw new Error(`LevelDef.pathLength invalid: ${data.pathLength}`);
    }
    // Freeze shallow copy so run state cannot mutate source defs.
    return Object.freeze({
        id: data.id,
        ...(data.name !== undefined ? { name: data.name } : {}),
        startN: Math.floor(data.startN),
        pathLength: data.pathLength,
        gates: Object.freeze([...(data.gates ?? [])].map((g) => Object.freeze({ ...g }))),
        waves: Object.freeze([...(data.waves ?? [])].map((w) => Object.freeze({ ...w }))),
        ...(data.pedestal !== undefined
            ? { pedestal: Object.freeze({ ...data.pedestal }) }
            : {}),
        ...(data.climaxWave !== undefined
            ? { climaxWave: Object.freeze({ ...data.climaxWave }) }
            : {}),
    });
}
/** Gates sorted by path Z ascending. */
export function sortedGates(level) {
    return [...(level.gates ?? [])].sort((a, b) => a.z - b.z);
}
/** Group gates that share the same Z into binary (or multi) decision sets. */
export function gateGroupsAtZ(level) {
    const map = new Map();
    for (const g of level.gates ?? []) {
        const key = g.z;
        const list = map.get(key) ?? [];
        list.push(g);
        map.set(key, list);
    }
    return map;
}
/**
 * Pick gate from a group by lateral position.
 * lane < 0 → left options; lane > 0 → right; lane 0 / missing → any.
 * For two-gate pairs: x < 0 chooses more-negative lane (or first), x >= 0 the other.
 */
export function pickGateByLateral(gates, lateralX) {
    if (gates.length === 0) {
        throw new Error("pickGateByLateral: empty gate group");
    }
    if (gates.length === 1) {
        return gates[0];
    }
    const sorted = [...gates].sort((a, b) => (a.lane ?? 0) - (b.lane ?? 0));
    // Prefer left half when lateralX < 0.
    if (lateralX < 0) {
        return sorted[0];
    }
    return sorted[sorted.length - 1];
}
//# sourceMappingURL=level.js.map